import { alpha } from '@mui/material';
var LightTheme = function (fontFamily) {
    return {
        // palette values for light mode
        primary: {
            dark: '#1414A0',
            main: '#1414A0',
            light: '#E8E8F6',
            lightSidebar: '#002B62',
            contrastText: '#fff',
        },
        error: {
            dark: '#DC3545',
            main: '#DC3545',
            light: '#DC3545',
            contrastText: '#fff',
        },
        secondary: {
            dark: '#1414A0',
            main: '#F8F9FA',
            light: alpha('#1D2433', 0.87),
            lightGray: alpha('#1D2433', 0.87),
            contrastText: '#000000de',
        },
        overlay: {
            main: alpha('#212529', 0.4),
        },
        neutral: {
            100: '#F5F5F5',
            200: '#F0F0F0',
            300: '#D9D9D9',
            500: '#8C8C8C',
        },
        danger: {
            dark: '#1414A0',
            main: '#DC3545',
            light: '#DC3545',
            secondary: alpha('#1414A0', 0.5),
        },
        border: {
            container: '#DBDBDB',
            textField: alpha('#000000', 0.23),
        },
        text: {
            primary: alpha('#000000', 0.87),
            'on-primary': '#fff',
            main: '#FFFFFF',
            secondary: '#99a1b7',
            disabled: alpha('#1D2433', 0.38),
            tertiary: alpha('#0F131A', 0.6),
            info: '#0E663D',
            success: '#084298',
            warning: '#755003',
            danger: '#A8222F',
        },
        textIcon: {
            primary: alpha('#1D2433', 0.87),
        },
        background: {
            default: '#FFFFFF',
            paper: '#FFFFFF',
            dialog: '#FFFFFF',
            blue: {
                500: '#1414A0',
                100: '#E7F1FF',
            },
        },
        fontFamily: fontFamily,
        spacing: 8,
        blue: {
            500: '#1414A0',
            100: '#E7F1FF',
        },
        red: {
            600: '#B02A37',
            100: '#F8D7DA',
        },
        green: {
            600: '#0E663D',
            100: '#D1E7DD',
        },
        grey: {
            900: '#F3F6F9',
            600: '#6C757D',
            200: '#E9ECEF',
        },
        common: {
            black: '#00204A',
            white: '#D1E7DD',
        },
    };
};
export default LightTheme;
